<template>
  <label
    :for="htmlFor"
    class="label"
    :class="[
      sizeClasses,
      {
        'label-required': required,
        'label-disabled': disabled,
        'label-error': error
      }
    ]"
  >
    <slot />
    <span v-if="required" class="text-red-500 ml-1" aria-label="Required">*</span>
  </label>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  htmlFor: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'md',
    validator: val => ['sm', 'md', 'lg'].includes(val)
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})

const sizeClasses = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'text-label' // 14px from design system
    case 'lg':
      return 'text-body' // 16px from design system
    case 'md':
    default:
      return 'text-label' // 14px default
  }
})
</script>
